/* global FormValidator:false */

// detect touch devices (global variable)
var isTouchDevice = 'ontouchstart' in document.documentElement || 'ontouchstart' in window || navigator.msMaxTouchPoints;

var isCSSTransitionSupported = function() {
	var b = document.body || document.documentElement,
		s = b.style,
		p = 'transition';

	if (typeof s[p] == 'string') { return true; }

	// Tests for vendor specific prop
	var v = ['Moz', 'webkit', 'Webkit', 'Khtml', 'O', 'ms'];
	p = p.charAt(0).toUpperCase() + p.substr(1);

	for (var i=0; i<v.length; i++) {
		if (typeof s[v[i] + p] == 'string') { return true; }
	}

	return false;
};

var matches = function(ele, selector) {
	return (
		ele.matches ||
		ele.matchesSelector ||
		ele.msMatchesSelector ||
		ele.mozMatchesSelector ||
		ele.webkitMatchesSelector ||
		ele.oMatchesSelector
	).call(ele, selector);
};

// Find the closest element to `ele` and matches the `selector`
var closest = function(ele, selector) {
	var e = ele;
	while (e) {
		if (matches(e, selector)) {
			break;
		}
		e = e.parentNode;
	}
	return e;
};

const trigger = function(element, eventName, params = {}) {
	if (window.CustomEvent && typeof window.CustomEvent === 'function') {
		var event = new CustomEvent(eventName, {detail: params});
	} else {
		var event = document.createEvent('CustomEvent');
		event.initCustomEvent(eventName, true, true, params);
	}

	element.dispatchEvent(event);
};

const resetAccessibleMessage = function(element) {
	element.setAttribute('aria-hidden', 'true');
	element.setAttribute('role', 'none');
	element.setAttribute('aria-live', 'off');
};

const setAccessibleMessage = function(element, role = 'status') {
	element.setAttribute('aria-hidden', 'false');
	element.setAttribute('role', role);
	element.setAttribute('aria-live', 'polite');
};



/**
 * Init form validations
 */

const formsWithValidator = document.querySelectorAll('form[data-validate]');
Array.prototype.forEach.call(formsWithValidator, function(form) {
	new FormValidator(form);

	// Shake with invalid forms
	form.addEventListener('forminvalid', function(e) {
		const details = e.detail;

		if (details.formElement) {
			details.formElement.classList.add('shake-animation');
			console.log(details.formElement);
			setTimeout(function() {
				details.formElement.classList.remove('shake-animation');
			}, 1000);
		}
	});
});
